import { FC } from "react"
import cn from "classnames"

import { getAssetStoredStatusLabel } from "utils/utils"
import Text from "components/Text/Text"
import { AssetStoredStatus as AssetStoredStatusEnum } from "models/AssetDisplayStatus"
import NoValue from "components/NoValue/NoValue"

export const getAssetStoredStatusColor = (status: AssetStoredStatusEnum): string => {
    return {
        [AssetStoredStatusEnum.stored]: 'bg-green-500',
        [AssetStoredStatusEnum.released]: 'bg-red-400',
    }[status] || 'bg-grey-400'
}

interface IAssetStoredStatusProps {
    status: AssetStoredStatusEnum
}

const AssetStoredStatus: FC<IAssetStoredStatusProps> = ({
    status,
}) => {
    const text = getAssetStoredStatusLabel(status)
    const bgColor = getAssetStoredStatusColor(status)

    if (status === AssetStoredStatusEnum.notApplicable) {
        return <NoValue>{text}</NoValue>
    }

    return <Text type="pSmallest" className={cn("px-1 font-bold color-white round-sm d-inline-block", bgColor)}>
        {text}
    </Text>
}

export default AssetStoredStatus
